import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import {
  isDevLocalBypassFromQueryParams,
  isDevLocalBypassMode,
  isLocalDevHostname
} from '@app/core/init/utils';

/**
 * Permite rotas exclusivas do modo dev local (`localhost` + `?mode=dev`).
 */
export const devLocalBypassGuard: CanMatchFn = () => {
  const router = inject(Router);

  if (!isLocalDevHostname()) {
    return router.createUrlTree(['/']);
  }

  const navigation = router.getCurrentNavigation();
  const navQueryParams =
    navigation?.extractedUrl?.queryParams ?? navigation?.finalUrl?.queryParams;

  if (isDevLocalBypassFromQueryParams(navQueryParams)) {
    return true;
  }

  if (isDevLocalBypassMode()) {
    return true;
  }

  return router.createUrlTree(['/']);
};
